import React from "react"
import styled from "styled-components"
import { motion } from "framer-motion"
import SweetButton from "../components/SweetButton"
import SweetToFind from "../components/SweetToFind"
import Prize from "../components/Prize"
import {
  useGameDispatchContext,
  useGameStateContext,
} from "../utils/gameReducer"
import { sweetData } from "../utils/sweetData"
import { imagePromise } from "../utils/imagePromise"
import { shuffleArray } from "../utils/shuffleArray"
import background from "../assets/pen-instore-background.jpg"
import Loading from "../components/Loading"
import TermsAndMusic from "../components/TermsAndMusic"

const GameLandscapeStyles = styled(motion.div)`
  width: 100%;
  height: 100vh;
  background: var(--gold);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  .landscape-background-container {
    cursor: grab;
    position: relative;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000;
    -webkit-transform: translate3d(0, 0, 0);
    -webkit-backface-visibility: hidden;
    -webkit-perspective: 1000;
    will-change: transform;
    :active {
      cursor: grabbing;
    }
    img {
      display: block;
      object-fit: cover;
      pointer-events: none;
      touch-action: none;
    }
  }
`

export default function Play() {
  const seconds = 75
  const secondsToAdd = 7

  const bronze = 1
  const silver = 3
  const gold = 5

  const constainerRef = React.useRef(null)
  const [loading, setLoading] = React.useState(true)
  const [height, setHeight] = React.useState("calc(100vh + 200px)")
  const [sweetArray, setSweetArray] = React.useState([])
  const [sweetNumber, setSweetNumber] = React.useState(0)
  const [timer, setTimer] = React.useState(seconds)
  const { score, prize } = useGameStateContext()
  const dispatch = useGameDispatchContext()

  function handleImageHeight() {
    setHeight(
      constainerRef.current.getBoundingClientRect().height > 1000
        ? constainerRef.current.getBoundingClientRect().height + 200
        : 1200
    )
  }

  function startNewGame() {
    let shuffledSweets = Array.from(sweetData.keys())

    dispatch({ type: "UPDATE_SCORE", score: 0 })
    dispatch({ type: "UPDATE_PRIZE", prize: "" })

    handleImageHeight()
    shuffleArray(shuffledSweets)
    setSweetArray(shuffledSweets)
    setTimer(seconds)
  }

  React.useEffect(() => {
    imagePromise(setLoading, 4000)
  }, [])

  React.useEffect(() => {
    !loading && startNewGame()
  }, [loading])

  React.useEffect(() => {
    const timeout = setInterval(() => {
      timer > 0 && setTimer(timer - 1)
    }, 1000)
    return () => clearInterval(timeout)
  }, [timer])

  React.useEffect(() => {
    setSweetNumber(sweetArray[score])
  })

  React.useEffect(() => {
    window.addEventListener("resize", handleImageHeight)
    return () => window.removeEventListener("resize", handleImageHeight)
  }, [])

  React.useEffect(() => {
    if (timer === 0 || score === gold) {
      setTimer(0)
      if (score < bronze) {
        dispatch({ type: "UPDATE_PRIZE", prize: "LOST" })
      } else if (score >= bronze && score < silver) {
        dispatch({ type: "UPDATE_PRIZE", prize: "BRONZE" })
      } else if (score >= silver && score < gold) {
        dispatch({ type: "UPDATE_PRIZE", prize: "SILVER" })
      } else if (score >= gold) {
        dispatch({ type: "UPDATE_PRIZE", prize: "GOLD" })
      }
    }
  }, [timer])

  return (
    <>
      <GameLandscapeStyles ref={constainerRef}>
        <motion.div
          drag
          dragConstraints={constainerRef}
          dragElastic={0.1}
          dragTransition={{ bounceStiffness: 1000, bounceDamping: 100 }}
          className="landscape-background-container"
        >
          <img src={background} alt="" style={{ height: height }} />
          {sweetData.map((sweet, i) => {
            return (
              <SweetButton
                key={sweet.id}
                top={sweet.top}
                left={sweet.left}
                id={sweet.id}
                image={sweet.image}
                sweetNumber={sweetNumber}
                seconds={seconds}
                secondsToAdd={secondsToAdd}
                timer={timer}
                setTimer={setTimer}
              />
            )
          })}
        </motion.div>
      </GameLandscapeStyles>
      <SweetToFind
        image={sweetData[sweetNumber]?.image}
        seconds={seconds}
        timer={timer}
        loading={loading}
      />
      <TermsAndMusic play />
      {prize && !loading && <Prize startNewGame={startNewGame} />}
      {loading && <Loading play />}
    </>
  )
}
